<div class="content">
  <nz-select [(ngModel)]="selectedProp" [compareWith]="compareFn" nzShowSearch nzAllowClear
    (ngModelChange)="setProp()">
    @for (col of columnDefinition; track $index) {
      <nz-option [nzLabel]="col.headerName!" [nzValue]="col"></nz-option>
    }
  </nz-select>
  <div class="drag placeholder-value">Beispielwert</div>
</div>
